import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import baseStyle from '../../../styles/games.js';
import { GAME_URL } from '../../../redux/constants';
import HearingIcon from '@material-ui/icons/Hearing';
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, IconButton, ListItemText, Tooltip, Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import { withStyles } from '@material-ui/core/styles/index';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import { runAnalysis, getStory, postPlaytime, localState, getStoryChapters, getStoryAsLazy, resetLazyFlag } from '../../../redux/actions/buddyBooks'
import StoryPage from '../../components/student/StoryPage.jsx';
import { getSavedSession, getStudent } from '../../../redux/actions/students.js';
import './styles.scss';
import _ from "lodash";
import SettingModal from '../../components/Setting/SettingModal.js';
import PauseMenu from '../../components/student/PauseMenu.js';
import { getSettings, modalState, panelClosing, settingsPanel, soundSettings } from '../../../redux/actions/settings.js';
import ProgressBar from '../../../utils/ProgressBar.js';
import Timer from '../../../utils/Timer.js';
import PageVisibility from 'react-page-visibility';
import StoryPageParagraph from '../../components/student/StoryPageParagraph.jsx';
import SearchBar from '../../components/SearchBar/index.js';
import { isMacintosh } from '../../../utils/utility.js';
import { QuestionMark } from '@mui/icons-material';
import { PlayArrow} from '@material-ui/icons';
import CloseIcon from '@mui/icons-material/Close';
import PauseIcon from '@mui/icons-material/Pause';

let chunks = [];
var superBuffer;
let analysisOffsets;
let computerOffsets;
let stopRecordingFired = false;
let textIndex = 0;
let skippedIndex = null;
let computerIndex = 0;
let mediaRecorder;
let speechEvents;
var localBlobUrl;
let resetRecording = false;
let togglePauseMenu = false;
let isReloaded = false;
let firstSpacebarPressed = false;
let speechPollToggle = false;
let deviceSinked = false;
let pronounceTime;
let blobIndex = 0;
let computerZeroIndex = false;
let differenceLessThan50 = false;
let recordingTimeout = null;
let firstRecording = true;
let lastTouchTime = 0;

class BuddyBooks extends Component {

    constructor(props) {
        super(props);

        this.data = new Blob([]);
        this.compAudRef = React.createRef();

        this.state = {
            data: this.data,
            text: "Test",
            index: 0,
            start: false,
            url: "",
            analysis: null,
            fadeToggle: false,
            playerType: false,
            playRecording: false,
            isMicRecording: false,
            highlightWordIndex: 0,
            errMsgReplay: '',
            reviewMode: false,
            isAppPaused: false,
            noSubmit: false,
            isSpacebarClicked: false,
            playedSegment: true,
            pageVisible: true,
            isSearchBarVisible: false,
            isPronounced: false,
            blobArr: [],
            isStoryComplete: false,
            modalIsOpen:false,
            wordMeaningInfo:"",
            openDictionaryModal:false,
            queryText:"",
            isIpad:false,
            restartBook:false,
            dictionaryLoading: false,
        };

        this.silenceTimeDelay = null;
        this.audio = new Audio(this.state.url);
        this.iteratePlayerAudio = this.iteratePlayerAudio.bind(this);
    }

    // Sets up speechEvents
    onSuccess = () => {
        this.setState({ startTime: Date.now() });

        // visualize(stream);
        let recording = () => {
            if (this.state.start) {
                stopRecordingFired = false;

                if (mediaRecorder.state !== "inactive") {
                    mediaRecorder.stop();
                }
                if(recordingTimeout) {
                    console.log("Destroying Timeout ", Date.now());
                    clearTimeout(recordingTimeout);
                    recordingTimeout = null;
                }

                this.setState({ start: false, isMicRecording: false })
            } else {
                try {
                    if (typeof window != "undefined" && window.inputDeviceError) {
                        var okToRefresh = window.confirm("Your recording will not start make sure you changed your microphone, Once changed please reload the page.");
                        if (okToRefresh) {
                            window.location.reload();
                        }
                    } else {
                        mediaRecorder.start();
                    }
                } catch (err) {
                    var okToRefresh = window.confirm("Failed to start media recorder, Please reload the page.");
                    if (okToRefresh) {
                        window.location.reload();
                    }
                }
                if(recordingTimeout) {
                    console.log("Destroying Timeout ", Date.now());
                    clearTimeout(recordingTimeout);
                    recordingTimeout = null;
                }
                if(true) {
                    console.log("Creating Timeout ", Date.now());
                    recordingTimeout = setTimeout(() => {
                        firstSpacebarPressed = true;
                        !this.state.isAppPaused && this.setState({
                            recordingText: <p>We can't hear you <br/> Please check your audio settings</p>,
                            isSpacebarClicked: !this.state.isSpacebarClicked
                        });
                        !this.state.isAppPaused && this.togglePlayer();
                    }, 10000);
                }
                this.setState({
                    startTime: Date.now(),
                    lastSpeakTime: Date.now(),
                    start: true,
                    isMicRecording: true,
                    errMsgReplay: 'Please wait for the analysis to replay.'
                });
                stopRecordingFired = false;
                speechEvents && speechEvents.on('speaking', () => {
                    console.log("Speaking");
                    firstRecording = false;
                    speechPollToggle = false;
                    if(recordingTimeout) {
                        console.log("Destroying Timeout ", Date.now());
                        clearTimeout(recordingTimeout);
                        recordingTimeout = null;
                    }
                });
                speechEvents && speechEvents.on('stopped_speaking', () => {
                    console.log("Stopped Speaking");
                    if (this.state.playerType && !speechPollToggle) {
                        speechPollToggle = true;
                        if(!recordingTimeout) {
                            console.log("Creating Timeout ", Date.now());
                            recordingTimeout = setTimeout(() => {
                                firstSpacebarPressed = true;
                                !this.state.isAppPaused && this.setState({
                                    recordingText: <p>We can't hear you <br/> Please check your audio settings</p>,
                                    isSpacebarClicked: !this.state.isSpacebarClicked
                                });
                                !this.state.isAppPaused && this.togglePlayer();
                            }, 10000);
                        }
                    }
                });
            }
        }

        let record = function () {
            if(recordingTimeout) {
                console.log("Destroying Timeout ", Date.now());
                clearTimeout(recordingTimeout);
                recordingTimeout = null;
            }
            this.setState({
                startTime: Date.now(),
                lastSpeakTime: Date.now()
            });
            try {
                mediaRecorder.start();
            } catch (err) {
                var okToRefresh = window.confirm("Failed to start media recorder, Please reload the page.");
                if (okToRefresh) {
                    window.location.reload();
                }
            }
        }

        let stop = function (analysis) {
            if(recordingTimeout) {
                console.log("Destroying Timeout ", Date.now());
                clearTimeout(recordingTimeout);
                recordingTimeout = null;
            }
            mediaRecorder.stop();
        }

        if (mediaRecorder) {
            !resetRecording && (mediaRecorder.onstop = this.onStop);

            mediaRecorder.ondataavailable = function (e) {
                chunks.push(e.data);
                superBuffer = new Blob(chunks.slice(-1));
                superBuffer =
                    window.URL.createObjectURL(superBuffer);
            }
        }
        this.setState({ recording, record, stop });
    }

    iteratePlayerAudio(e) {
        let { currentTime } = e.target;
        let oldTextIndex = textIndex;
        if (analysisOffsets && analysisOffsets.length) {
            while ((textIndex < analysisOffsets.length - 1) && ((currentTime * 1000) > (analysisOffsets[textIndex] / 10000))) {
                textIndex++;
            }
            if ((oldTextIndex !== textIndex) && ((textIndex - oldTextIndex) === 1)) {
                this.setState({ highlightWordIndex: textIndex });
            } else if ((textIndex > oldTextIndex) && ((textIndex - oldTextIndex) > 1)) {
                skippedIndex = textIndex;

                this.setState({ highlightWordIndex: (textIndex - 1) });
                setTimeout(() => {

                    this.setState({ highlightWordIndex: skippedIndex });
                }, 200);
            }
        }
    }

    handleStartComputerAudio = () => {
        this.setState({ playComputer: true });
    }

    // Make sure whether computer needs to continue reading the next blob object or stop and pass control to player
    handleEndComputerAudio = () => {
        blobIndex++;
        if (this.state.blobArr.length > 0 && blobIndex <= this.state.blobArr.length - 1) {
            this.setState({ index: this.state.index + 1, highlightWordIndex: 0 });
            computerIndex = 0;
            this.resumeStory();

        } else {
            blobIndex = 0;
            let currentSection = this.state.story.storySegmentDto.find(segment => segment.section == this.state.index)?.groupNumber;
            let storySegmentDto = this.state?.story?.storySegmentDto;
            let text = '';
        storySegmentDto && storySegmentDto.forEach(item => {
            if (item?.groupNumber === currentSection) {
                text += ' ' + item.text;
            }
        });
            let getLastText = storySegmentDto && storySegmentDto[storySegmentDto.length - 1].text;
            if ((this.state.index + this.state.blobArr.length) >= this.props.storyLength) {
                this.setState({ isStoryComplete: true })
            }
            this.setState({ playComputer: false, blobArr: [] });
            if (this.props.settings && !this.props.settings.modalState.isQuestionClicked) {
                this.onNext();
            }
        }
    }

    // Called every time computer is speaking, responsible for moving the highlighter to next word.
    iterateComputerAudio(e) {
        let compAud = document.getElementById("compAud");
        let { currentTime } = e.target;
        compAud.playbackRate = this.state?.settings.playbackSpeed || 1;
        let oldTextIndex = computerIndex;
        if (computerOffsets && computerOffsets[blobIndex] && computerOffsets[blobIndex].length) {
            //If currentTime exceeds the designated time for particular word, we need to move ahead 
            while ((computerIndex <= computerOffsets[blobIndex].length - 1) && ((currentTime) * 1000 > (computerOffsets[blobIndex][computerIndex]))) {
                computerIndex++;
            }
            if ((oldTextIndex !== computerIndex) && ((computerIndex - oldTextIndex) === 1)) {
                this.setState({ highlightWordIndex: computerIndex });
            } else if ((computerIndex > oldTextIndex) && ((computerIndex - oldTextIndex) > 1)) {
              // If somehow the current time passes very fast and skips a index we move back 1 and then after 200ms move ahead.
                skippedIndex = computerIndex;

                this.setState({ highlightWordIndex: (computerIndex - 1) });
                setTimeout(() => {

                    this.setState({ highlightWordIndex: skippedIndex });
                }, 200);
            }
        }
    }

    // Stops/Plays the player recording
    togglePlayer = () => {
        if (this.state.start) {
            mediaRecorder.state === "recording" && mediaRecorder.stop();
            speechPollToggle = true;
            this.setState({ start: false, isAppPaused: true, noSubmit: true });
        } else {
            this.setState({ isAppPaused: !this.state.isAppPaused, recordingText: '' });
        }
    }

    toggleComputerAudio = (analysis) => {
        togglePauseMenu = !togglePauseMenu;
        this.setState({ playComputer: !this.state.playComputer, highlightWordIndex: 0 });
        computerIndex = 0;
    }

    // Called when its player turn and it clicks pause
    onStop = (e) => {
        if(recordingTimeout) {
            console.log("Destroying Timeout ", Date.now());
            clearTimeout(recordingTimeout);
            recordingTimeout = null;
        }
        if (!this.state.isAppPaused && !this.state.noSubmit) {
            const blob = new Blob(chunks.slice(-1), { 'type': 'audio/webm;codecs=pcm' });
            chunks = [];
            this.setState({ "data": blob });
            let currentSection;
            if (this.state.story) {
                currentSection = this.state.story.storySegmentDto.find(segment => segment.section == this.state.index)?.groupNumber;
            }
            this.onSubmit(currentSection);
            // this.downloadBlob(blob, "audio.webm");
            !this.state.reviewMode && this.onNext();
        }
    }

    onSubmit = (currentSection) => {
        if(recordingTimeout) {
            console.log("Destroying Timeout ", Date.now());
            clearTimeout(recordingTimeout);
            recordingTimeout = null;
        }
        let savedUser = localStorage.getItem("logged_user");
        const person = savedUser && JSON.parse(savedUser);
        let storySegmentDto = this.state?.story?.storySegmentDto;
        let text = '';
        storySegmentDto && storySegmentDto.forEach(item => {
            if (item?.groupNumber === currentSection) {
                // if (item.text.includes('.')) {
                //     item.text = item.text.replace(/\./, '. ');
                // }
                text += ' ' + item.text;
            }
        });
        console.log("onSubmit text ", text);
        const url = `${GAME_URL}/speech/${person.info?.personId}/upload`;
        var data = { "possibleCorrect": [text], "possibleIncorrect": [] }
        var id = this.props.id;
        var blob = this.state.data;
        //0207cb2d-2ee5-4645-98cc-821d57ed26b7
        const config = {
            headers: {
                'access-token': `${this.props?.auth?.token}`
            }
        };
        axios.post(url, data, config)
            .then((response) => {
                var speechId = response.data.id;
                this.props.dispatch(runAnalysis(speechId, id, blob, currentSection, superBuffer));
                this.setState({ data: this.data });
            });
        let getLastText = storySegmentDto && storySegmentDto[storySegmentDto.length - 1].text;
        let segmentCount = 0;
        storySegmentDto.forEach(val =>{if(val.groupNumber === currentSection){segmentCount++}});
        if (((this.state.index + segmentCount) >= this.props.storyLength)) {
            this.setState({ isStoryComplete: true })
        }
    }

    //Currently not used
    downloadBlob = (blob, name = 'file.txt') => {
        if (
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) return window.navigator.msSaveOrOpenBlob(blob);

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = data;
        link.download = name;

        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            })
        );

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
    }

    // Called when closing the page
    handleUnload = () => {
        const storySegment = this.state.story.storySegmentDto[this.state.index];
        let newIndex = this.state.index;
        const { storySegmentDto } = this.state.story;
        let groupNumber = storySegment?.groupNumber;
        if (storySegment?.type != "Computer") {
            while (newIndex >= 0 && storySegmentDto[newIndex]?.groupNumber > groupNumber - 2) {
                newIndex--;
            }
            newIndex++;
        } else {
            while (newIndex >= 0 && storySegmentDto[newIndex]?.groupNumber > groupNumber - 1) {
                newIndex--;
            }
            newIndex++;
        }
        localStorage.setItem("current_section", JSON.stringify({ id: this.props.id, section: newIndex }))
    }

    // Called everytime props update, sets the index and currentSection
    handleReload = (data, storyDto, storySegmentDto) => {
        if (isReloaded) {
            this.props.dispatch(getStudent());
            isReloaded = false;
            if (data && this.state.index === 0) {
                let indexes = data && JSON.parse(data.indexes);
                let currentGroup = parseInt(data.currentSection) === -1 ? 0 : parseInt(data.currentSection);
                let nextIndex = this.getIndexFromGroup(currentGroup, storySegmentDto);

                let storyLength = storySegmentDto.length;
                let lastGroup = storySegmentDto[storyLength - 1]?.section;
                if (storySegmentDto && parseInt(data.currentSection) + 2 < lastGroup) {
                    localStorage.setItem("current_section", JSON.stringify({ id: storyDto.id, section: nextIndex }));
                    this.setState({ index: nextIndex });
                }

                if (data.session !== this.props.auth.token) {
                    let reviewDone = localStorage.getItem(`review_done`);
                    if (reviewDone === "false" && !_.isEmpty(indexes)) {
                        this.props.history.push('/review_page');
                    }
                }
            }
        }
    };

    resumeStory = () => {
        this.setState({ recordingText: '', isStoryComplete: false });
        this.changeToCurrentSection();
    }

    changeToCurrentSection = () => {
        let cS = localStorage.getItem("current_section");
        let currentSection;
        if (cS) {
            currentSection = JSON.parse(cS);
        } else {
            let data = this.props.savedSessionResponse.data;
            localStorage.setItem("current_section", JSON.stringify({ id: this.props.id, section: this.state.index }));
            cS = localStorage.getItem("current_section");
            currentSection = JSON.parse(cS);
        }
        if (this.state.playerType) {
            mediaRecorder.state === "recording" && mediaRecorder.stop();
            speechPollToggle = false;
        }
        this.setState({ playComputer: false, playerType: false, noSubmit: true, start: false, isMicRecording: false, url: '', playedSegment: false });
        if (!_.isEmpty(this.state.story)) {
            if (currentSection) {
                let storySegment = this.state.story?.storySegmentDto.find(segment => segment.section == currentSection.section);
                let newIndex = currentSection.section;
                const { storySegmentDto } = this.state.story;
                let groupNumber = storySegment?.groupNumber;
                let ind = this.state.story?.storySegmentDto.findIndex(segment => segment.section == newIndex);
                if (storySegment?.type != "Computer") {
                    while (newIndex >= 0 && storySegmentDto[ind]?.groupNumber > groupNumber - 2 && blobIndex === 0) {
                        newIndex--;
                        ind = this.state.story?.storySegmentDto.findIndex(segment => segment.section == newIndex);
                    }
                    newIndex++;
                } else {
                    while (newIndex >= 0 && storySegmentDto[ind]?.groupNumber > groupNumber - 1 && blobIndex === 0) {
                        newIndex--;
                        ind = this.state.story?.storySegmentDto.findIndex(segment => segment.section == newIndex);
                    }
                    if(blobIndex != 0 ){
                        this.setState({ index: newIndex });
                        localStorage.setItem("current_section", JSON.stringify({ id: this.props.id, section: newIndex }));
                    return;
                    }
                    newIndex++;
                }
                computerIndex = 0;
                textIndex = 0;
                this.setState({ index: newIndex });
                localStorage.setItem("current_section", JSON.stringify({ id: this.props.id, section: newIndex }));
            } else {
                let newIndex = parseInt(this.props.savedSessionResponse.data?.currentSection) + 1;
                newIndex = newIndex;
                this.setState({ index: newIndex || 0 })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let storyId = this.props.story.storyDto && this.props.story.storyDto.id;
        let nextStoryId = nextProps.story.storyDto && nextProps.story.storyDto.id
        if ((_.isEmpty(this.props.story)) || (nextStoryId && storyId !== nextStoryId)) {
            let bookStory = localStorage.getItem("book_story");
            bookStory = bookStory && JSON.parse(bookStory);
            let bookId = localStorage.getItem("book_id");
            let cS = localStorage.getItem("current_section");
            let currentSection = cS && JSON.parse(cS);
            if (_.isEmpty(nextProps.story) && !this.state.story) {
                bookStory && bookId && (bookStory.storyDto.id == bookId) && this.setState({ story: bookStory });
                // bookStory && currentSection && (bookStory.storyDto.id == currentSection.id) && this.setState({ index: currentSection.section });
            } else {
                if (!bookStory && !bookId || !(bookStory?.storyDto?.id == bookId)) {
                    this.setState({ story: nextProps.story }, () => {
                        this.state.playedSegment && this.setState({ playedSegment: false })
                    });
                    // this.setState({ index: 0 });
                }
            }
        }

        if (this.props.settings.data !== nextProps.settings.data) {
            nextProps.settings.data && (document.body.style.background = nextProps.settings?.bgColor);
        }

        if (!_.isEmpty(this.props.story) && !this.state.story) {
            this.setState({ story: nextProps.story });
        }
        if (!_.isEmpty(this.props.story) && this.state.story !== nextProps.story) {
            this.setState({ story: nextProps.story });
            if (differenceLessThan50) {
                this.props.dispatch(localState({ isNextHundredStoryAdded: true }));
                differenceLessThan50 = false;
            }
        }
        if (!_.isEmpty(this.props.storyChapters) && !this.state.storyChapters) {
            this.setState({ storyChapters: nextProps.storyChapters });
        }
        let urlUpdated = this.state.url;
        let outputDeviceId = this.props.settings.soundDevices.output;
        let outputDeviceUpdated = this.props.settings.soundDevices.output !== nextProps.settings.soundDevices.output;
        if (outputDeviceUpdated) {
            deviceSinked = false;
        }

        if (urlUpdated && this.state.playComputer && outputDeviceId) {
            this.changeAudioDestination();
            deviceSinked = true;
        }

        if (this.state.playComputer && this.state.isSearchBarVisible) {
            this.setState({ playComputer: false, highlightWordIndex: null });
            computerIndex = 0;
        }

        if (nextProps.currentAnalysis) {
            if (nextProps.currentAnalysis && nextProps.currentAnalysis.NBest) {
                analysisOffsets = nextProps.currentAnalysis.NBest[0].Words.map((value) => {
                    return value.offset;
                });
            }
        }

        if (this.props.savedSessionResponse.data !== nextProps.savedSessionResponse.data && this.state.playedSegment) {
            if (isReloaded && nextProps.savedSessionResponse.data) {
                let data = nextProps.savedSessionResponse.data;
                let currentGroup = parseInt(data.currentSection) === -1 ? 0 : parseInt(data.currentSection);
                let sectionStart = Math.sign(currentGroup - 100) === -1 ? 0 : currentGroup - 100;
                !window.getStoryCalled && this.props.dispatch(getStoryAsLazy(this.props.id, sectionStart, 200));
            } else {
                let reviewDone = localStorage.getItem(`review_done`);
                let data = nextProps.savedSessionResponse.data;
                let indexes = data && JSON.parse(data.indexes);
                if (data.session !== this.props.auth.token && reviewDone === "false" && !_.isEmpty(indexes)) {
                    this.props.history.push('/review_page');
                } else {
                    let storySegmentDto = this.props.story.storySegmentDto;
                    let currentGroup;
                    currentGroup = parseInt(data.currentSection) === -1 ? 0 : parseInt(data.currentSection);
                    let nextIndex = this.getIndexFromGroup(currentGroup, storySegmentDto);
                    this.setState({ index: nextIndex }, () => {
                        this.setState({ playedSegment: false })
                    });
                }
            }

        }

        if (nextProps.savedSessionResponse.data && nextProps.story.storyDto && nextProps.story.storyDto.id && window.objMd && window.objMd.mediaRecorder) {
            this.handleReload(nextProps.savedSessionResponse.data, nextProps.story.storyDto, nextProps.story.storySegmentDto);
        }

        if (this.props.settings.modalState.isQuestionClicked !== nextProps.settings.modalState.isQuestionClicked) {
            let boolVal = nextProps.settings.modalState.isQuestionClicked;
            this.setState({ isQuestionClicked: boolVal })
        }

        if (nextProps.localData &&
            nextProps.localData.queryText &&
            nextProps.settings &&
            nextProps.settings.modalState.isQuestionClicked) {
            let queryText = nextProps.localData.queryText;
            this.props.dispatch(localState({ queryText: '' }));
            this.playQueryText(queryText);
        }
        if(
            nextProps && nextProps.settings
            && this.props.settings.soundDevices && nextProps.settings.soundDevices
            && this.props.settings.soundDevices.input != nextProps.settings.soundDevices.input) {
            this.generateInputStream(nextProps.settings.soundDevices);
        }

    }
    // Sets up the system in place to enable audio functionality
    generateInputStream = (soundDevices) => {
        if (typeof window != 'undefined') {
                let { input } = soundDevices;
            let config = {"deviceId": {"exact": input}}
                const gmCallback = () => {
                    mediaRecorder = window.objMd && window.objMd.mediaRecorder;
                    speechEvents = window.objMd && window.objMd.speechEvents;
                    this.onSuccess();
                }
                window.afterGlobalMedia(gmCallback, config, true);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {settings, story, localData, lazyStoryAdded } = this.props;
        if (this.state.index !== prevState.index) {
            computerIndex = 0;
            textIndex = 0;
            this.setState({ playedSegment: false })
            if (this.state.playerType) {
                this.setState({ highlightWordIndex: 0 });
            } else this.setState({ highlightWordIndex: 0 });

            if (!_.isEmpty(story) && this.state.index) {
                let storyLength = story.storySegmentDto.length - 1;
                let lastSection = story.storySegmentDto[storyLength]?.section;
                let diff = lastSection - this.state.index;
                // let sectionStart = story.storySegmentDto[storyLength].groupNumber + 1;
                let sectionStart = story.storySegmentDto.find(s => s.section == this.state.index)?.groupNumber;
                if (diff === 50 || diff < 50) {
                    this.props.dispatch(getStoryAsLazy(this.props.id, sectionStart - 100, 200));
                    differenceLessThan50 = true;
                }
            }
        }
        if (prevProps.story !== story && !_.isEmpty(story) && ((localData.isSkippedToSearch && !localData.isSkipStoryUpdated) || lazyStoryAdded)) {
            this.setState({ story: story });
            this.props.dispatch(localState({ isSkipStoryUpdated: true, isSkippedToSearch: true }));
            lazyStoryAdded && this.props.dispatch(resetLazyFlag());
        }

        if (prevState.story !== this.state.story && !_.isEmpty(story) && localData.isSkippedToSearch) {
            this.changeToCurrentSection();
            this.props.dispatch(modalState({ isModalOpen: false, isQuestionClicked: false }));
        }

        if (prevProps.settings.isSettingsMenuOpen !== settings.isSettingsMenuOpen && settings.isSettingsMenuOpen) {
            blobIndex = 0;
        }
        if(prevProps.story !== story && this.state.restartBook){
            this.setState({ story : story, restartBook: false })
        }
        if(prevState.story!==this.state.story){
            if(this.state.story.storySegmentDto.length===0){
                this.setState({modalIsOpen:true})
            }
            else{
                this.setState({modalIsOpen:false})
            }
        }
        // if(prevState.story !== this.state.story){
        //     if(this.state.story.storySegmentDto.length > 0){
        //         let data = this.props.savedSessionResponse.data;
        //         let currentGroup = parseInt(data.currentSection) === -1 ? 0 : parseInt(data.currentSection);
        //         let storySegmentDto = this.props.story.storySegmentDto;
        //         let nextIndex = this.getIndexFromGroup(currentGroup, storySegmentDto);
        //             this.setState({ index: nextIndex }, () => {
        //                 this.setState({ playedSegment: false })
        //             });
        //     }
        // }
    }
    // Moves the index to next section
    onNext = () => {
        this.setState({ fadeToggle: !this.state.fadeToggle, errMsgReplay: '', isAppPaused: false, noSubmit: false, playedSegment: false });
        let switchTime = 0;
        let nextIndex;
        const { format } = this.state.story.storyDto;

        let storySegmentDto = this.state.story.storySegmentDto;
        let storySegment = storySegmentDto.find(segment => segment.section == this.state.index);
        let groupSection = storySegment?.groupNumber + 1;
        let indexFound = false;
        storySegmentDto && storySegmentDto.forEach(item => {
            if (item?.groupNumber === groupSection && !indexFound) {
                nextIndex = item?.section;
                indexFound = true;
            }
        })

        setTimeout(() => {
            if (nextIndex)
                this.setState({ index: nextIndex, url: "" }, () => {
                    let storySegment = storySegmentDto.find(segment => segment.section == this.state.index);
                    stopRecordingFired = false;
                    if ((storySegment && storySegment.type === "Player")) {
                        switchTime = 2000;
                        this.setState({ playerType: true });
                        this.state.recording();
                    } else {
                        this.setState({ playerType: false });
                    }
                    localStorage.setItem("current_section", JSON.stringify({ id: this.props.id, section: this.state.index }))
                });
        }, switchTime)
    }


    handleKeyDown = (e) => {
        let code = e.keyCode;

        //Enter key
        if (code === 13 && !this.state.isSearchBarVisible) {
            e.preventDefault();
            this.state.playerType && document.getElementById("recordBtn").click();
        };

        //spacebar key
        if (code === 32 && !this.state.isSearchBarVisible) {
            e.preventDefault();
            if (this.props.settings && !this.props.settings.modalState.isQuestionClicked) {
                firstSpacebarPressed = true;
                this.setState({ isSpacebarClicked: !this.state.isSpacebarClicked });
            }
        };

        //Override Find
        if (this.props.settings && !this.props.settings.modalState.isQuestionClicked) {
            if (isMacintosh && (e.metaKey && e.keyCode === 70)) {
                e.preventDefault();

                this.setState({ isSearchBarVisible: true });
            } else if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
                e.preventDefault();

                this.setState({ isSearchBarVisible: true });
            }
        }

        //Escape key: quit pronouncing by the question mark
        if ((code === 27 || this.isDoubleTapped()) && this.props.settings.modalState.isQuestionClicked ) {
            let cursor = document.getElementById("qPointer");
            if (cursor) {
                cursor.removeAttribute("style");
                document.body.style.removeProperty("cursor");
                this.props.dispatch(modalState({ isModalOpen: false, isQuestionClicked: false }));
                this.setState({ playedSegment: false, url: '', highlightWordIndex: 0 });
                computerIndex = 0;
            }
        }
    }

    isDoubleTapped=()=> {
        const now = Date.now();
        const doubleTapThreshold = 300; // milliseconds
      
        if (now - lastTouchTime < doubleTapThreshold) {
          lastTouchTime = now;
          return true
        }
        else{
            lastTouchTime = now;
            return false
        }
      }

    pronounceQueryText = (e) => {
        // const { isQuestionClicked } = this.props.settings.modalState;
        if (this.state.queryText && !this.state.isPronounced) {
            this.setState({ isPronounced: true, highlightWordIndex: null })
            pronounceTime = setTimeout(() => {
                this.setState({ isPronounced: false })
            }, 1000);
            this.playQueryText(this.state.queryText);
        }
    }

    async componentDidMount() {
        let bookId = localStorage.getItem("book_id");
        let bookStory = localStorage.getItem("book_story");
        bookStory = bookStory && JSON.parse(bookStory);
        if (_.isEmpty(this.props.story)) {
            if (this.props.settings.data === null && !bookStory) {
                // !window.getStoryCalled && this.props.dispatch(getStoryAsLazy(this.props.id));
                !window.getStoryChaptersCalled && this.props.dispatch(getStoryChapters(this.props.id));
                !this.props.savedSessionResponse.data && !window.getSavedSessionCalled && this.props.dispatch(getSavedSession(this.props.id));
                !window.getSettingsCalled && this.props.dispatch(getSettings());
                isReloaded = true;
            } else {
                if (bookStory && bookId && (bookStory.storyDto.id == bookId)) {
                    this.setState({ story: bookStory });
                    let cS = localStorage.getItem("current_section");
                    if (cS) {
                        let currentSection = JSON.parse(cS);
                        let section = currentSection.section;
                        let currentIndex;
                        section = (section || section == 0) && (section % 2 === 0) ? section : section - 1;
                        currentIndex = section || this.props.savedSessionResponse.data.currentSection + 1;
                        this.setState({ index: currentIndex });
                    }
                }
            }
        } else {
            if (this.props.savedSessionResponse.data) {
                let storySegmentDto = this.props.story.storySegmentDto;
                let data = this.props.savedSessionResponse.data;
                let indexes = data && JSON.parse(data.indexes);
                let currentGroup;
                currentGroup = parseInt(data.currentSection) === -1 ? 0 : parseInt(data.currentSection);
                let nextIndex = this.getIndexFromGroup(currentGroup, storySegmentDto);

                let lastGroupNumber = storySegmentDto && storySegmentDto[storySegmentDto.length - 1]?.groupNumber;
                if (storySegmentDto && currentGroup <= lastGroupNumber) {
                    this.props.dispatch(localState(parseInt(data.currentSection) + 1));
                    localStorage.setItem("current_section", JSON.stringify({ id: bookId, section: nextIndex }));
                    this.setState({ index: nextIndex });
                }

                if (data.session !== this.props.auth.token) {
                    let reviewDone = localStorage.getItem(`review_done`);
                    reviewDone = JSON.parse(reviewDone);
                    if (!reviewDone && !_.isEmpty(indexes)) {
                        this.props.history.push('/review_page');
                    } else {
                        localStorage.setItem(`review_done`, true);
                        this.setState({ story: this.props.story, storyChapters: this.props.storyChapters }, () => {
                            this.state.playedSegment && this.setState({ playedSegment: false })
                        });
                        reviewDone = true;
                    }
                }

            } else {
                this.setState({ story: this.props.story, storyChapters: this.props.storyChapters }, () => {
                    this.state.playedSegment && this.setState({ playedSegment: false })
                });
            }
        }

        window.addEventListener('beforeunload', this.handleUnload);
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('selectionchange', this.handleTextSelection);
        document.addEventListener('touchstart',this.handleKeyDown)
        this.generateInputStream("default");

        if(/MacIntel/i.test(navigator.platform) || /Macintosh/i.test(navigator.userAgent)){
            if((navigator.maxTouchPoints && navigator.maxTouchPoints > 2)){             
                this.setState({isIpad:true})
            }
        }

    }

    //Gives the computer index which we want to play 
    getIndexFromGroup = (currentGroup, storySegmentDto) => {
        let currentIndex;
        let nextIndex;
        let currentType;
        let nextType;


        let indexFound = false;
        let nextIndexFound = false;
        let firstIndexFound = false;
        let lastGroupNumber = storySegmentDto[storySegmentDto.length - 1]?.groupNumber;

        storySegmentDto && storySegmentDto.forEach(item => {
            if (item.groupNumber === currentGroup && !indexFound) {
                currentIndex = item.section;
                currentType = item.type;
                indexFound = true;
            }

            if (item.groupNumber === currentGroup + 1 && !nextIndexFound) {
                nextIndex = item.section;
                nextType = item.type;
                nextIndexFound = true;
            }

            if (currentGroup + 1 > lastGroupNumber && item.type === 'Computer' && !firstIndexFound) {
                nextIndex = item.section;
                currentIndex = item.section;
                firstIndexFound = true;
            }
        })

        // We have reached the last segment of story and it is stuck on player type
        if (currentGroup == storySegmentDto[storySegmentDto.length-1]?.groupNumber && storySegmentDto[storySegmentDto.length-1]?.type == "Player" ){
            storySegmentDto && storySegmentDto.forEach(item => {
                if (item?.groupNumber == currentGroup-1){
                    nextIndex = item.section;
                    return;
                }
            });
     }
        if (currentType === 'Computer') {
            nextIndex = currentIndex;
        }
        return nextIndex;
    }

    // Plays the given segment
    playSegment = async (storySegment) => {
        if (this.state.blobArr.length === 0) {
            this.setState({ playedSegment: true });
            var text = '';
            let textArr = [];
            if (!_.isEmpty(this.state.story)) {
                const { storySegmentDto } = this.state.story;
                let groupNumber = storySegmentDto.find(segment => segment.section == this.state.index)?.groupNumber;

                storySegmentDto.forEach(item => {
                    if (item?.groupNumber === groupNumber) {
                        //If the item is only punctuation, it will not have an audio file and must be skipped.
                        if(item.text.replace(/[^\p{L}\p{N}\s]/gu, '').trim()!="") {
                            textArr.push(item.id);
                        }
                    }
                })
            }

            const config = {
                responseType: 'blob',
                headers: {
                    'access-token': `${this.props?.auth?.token}`
                }
            };

            var proms = textArr.map(id => axios.post(`${GAME_URL}/buddy-books/audio/${id}`, { id }, config).then(r => r.data));

            Promise.all(proms).then(blobs => {
                let blobArr = [];
                let blobUrl;
                for (let i = 0; i < blobs.length; i++) {
                    blobArr.push(blobs[i]);
                }
                this.setState({ blobArr: blobArr });
                let blob = new Blob(blobArr);
                blobUrl = URL.createObjectURL(blobArr[blobIndex]);

                this.setState({ url: blobUrl, playComputer: true, playRecording: false, highlightWordIndex: 0 });
                computerIndex = 0;

                let storySegmentDto = this.state.story.storySegmentDto;
                let groupSection = storySegment?.groupNumber;
                let newTiming = [];
                storySegmentDto && storySegmentDto.forEach(item => {
                    let lastOffset;
                    if (item?.groupNumber === groupSection) {
                        if (item.section !== this.state.index) {
                            lastOffset = newTiming[newTiming.length - 1];
                            newTiming = JSON.parse(item.timing).map((value) => {
                                return value.offset;
                            });
                            computerOffsets && computerOffsets.push([...newTiming]);
                        } else {
                            computerOffsets = [];
                            newTiming = JSON.parse(item.timing).map((value) => {
                                return value.offset;
                            });
                            computerOffsets.push([...newTiming]);
                        }
                    }
                })
            });
        } else {
            let blobUrl = URL.createObjectURL(this.state.blobArr[blobIndex]);
            this.setState({ url: blobUrl, playComputer: true, playRecording: false });
        }
    }

    // To pronounce selelected word
    playQueryText = async (queryText) => {
        const url = `${GAME_URL}/tts`;
        var data = { text: queryText }
        const config = {
            responseType: 'blob',
            headers: {
                'access-token': `${this.props?.auth?.token}`
            }
        };
        var response = await axios.post(url, data, config);
        let blobUrl = URL.createObjectURL(response.data);
        if (response.data.size && this.state.url !== blobUrl && this.state.openDictionaryModal) {
            this.setState({ url: blobUrl, playComputer: true, playRecording: false });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('touchstart',this.handleKeyDown)
        document.removeEventListener('selectionchange', this.handleTextSelection);
        document.body.style.background = '#ddf0ff';
        clearTimeout(pronounceTime);
    }

    getLocalSettings = (settings) => {
        this.setState({ settings: settings });
        document.body.style.background = settings?.bgColor;
    }

    setPlaytime = () => {
        this.props.dispatch(postPlaytime());
    }

    handleVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({ pageVisible: true });
        } else {
            this.setState({ pageVisible: false });
        }
    }

    attachSinkId = (element, sinkId) => {
        if (typeof element.sinkId !== 'undefined') {
            element.setSinkId(sinkId)
                .then(() => {
                    // console.log(`Success, audio output device attached: ${sinkId}`);
                })
                .catch(error => {
                    let errorMessage = error;
                    if (error.name === 'SecurityError') {
                        errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
                    }
                    console.error(errorMessage);
                    // Jump back to first output device in the list as it's the default.
                    this.props.dispatch(soundSettings(true));
                });
        } else {
            console.warn('Browser does not support output device selection.');
        }
    }

    changeAudioDestination = () => {
        const audioElement = document.getElementById('compAud');
        this.attachSinkId(audioElement, this.props.settings.soundDevices.output);
    }

    openSearchBar = (setOpen) => {
        setOpen(true);
        if (this.state.playerType) {
            this.props.dispatch(panelClosing({ searchPanel: true }));
            this.togglePlayer();
        } else {
            this.state.playComputer && this.toggleComputerAudio();
        }
        this.setState({ isSearchBarVisible: true });
        this.props.dispatch(modalState({ isModalOpen: true, isQuestionClicked: false }));
    }

    closeSearchBar = (setOpen) => {
        setOpen(false);
        computerIndex = 0;
        this.setState({ isSearchBarVisible: false, highlightWordIndex: 0 });
        if (!this.props.localData.isSkippedToSearch) {
            this.resumeStory();
            this.props.dispatch(modalState({ isModalOpen: false, isQuestionClicked: false }));
        }
    }

    jumpToSection = (section) => {
        blobIndex = 0;
        this.setState({ index: section, blobArr: [], url: '', playComputer: false, playedSegment: false, isStoryComplete: false });
    }

    handlePointer = () => {
        this.setState({ playComputer: false, highlightWordIndex: null })
        this.props.dispatch(modalState({ isModalOpen: true, isQuestionClicked: true }));
        if (this.state.playerType) {
            this.resumeStory();
        }
        let cursor = document.getElementById("qPointer");
        cursor.style.display = "block";
        document.addEventListener("mousemove", moveCursor);
        document.body.style.cursor = "none";
        function moveCursor(e) {
            cursor.style.top = `${e.pageY}px`;
            cursor.style.left = `${e.pageX}px`;
        }
    }
    getWordMeaning=async (queryText)=>{
            this.setState({dictionaryLoading:true})
            const url= `https://api.dictionaryapi.dev/api/v2/entries/en/${queryText}`;
            const config = {
                withCredentials: false,
            };
        try {
            const response = await axios.get(url,config)
        if(response.status === 200){
            const meaning = response.data[0];
        const definition = meaning.meanings[0]?.definitions[0].definition;

        const wordMeaning = {
          word: meaning.word,
          phonetic: meaning.phonetic,
          definition: definition,
          audioLink: null,
        };

            this.setState({
                wordMeaningInfo:wordMeaning,
                dictionaryLoading: false
            })
        }
        else {
            this.setState({wordMeaningInfo:{error:"No Definitions Found"}, dictionaryLoading: false})
        }
        } catch (error) {
            this.setState({wordMeaningInfo:{error:"No Definitions Found"}, dictionaryLoading: false})
            console.error(error)
        }
    }

    closeDictionaryModal=()=>{
        this.handlePointer()
        this.setState({
            openDictionaryModal:false,
            queryText:"",
            url:"",
            wordMeaningInfo:""
        })
    }

    handleTextSelection=()=>{
        let queryText = document.getSelection().toString();
        if(queryText && this.props.settings.modalState.isQuestionClicked && !this.state.openDictionaryModal){
            this.getWordMeaning(queryText)
        this.setState({openDictionaryModal:true,queryText})
        let cursor = document.getElementById("qPointer");
            if (cursor) {
                cursor.removeAttribute("style");
                document.body.style.removeProperty("cursor");
            }
        }
    }

    pronounceWord=()=>{
            this.setState({ playComputer: true, playRecording: false })
            if(this.state.isIpad){
                if(this.compAudRef && this.compAudRef.current){
                    this.compAudRef.current.play();
                }
            }
    }

    showDefinition=()=>{
        return this.state.wordMeaningInfo.error ? <Typography variant='h6' style={{textAlign:"center"}}>{this.state.wordMeaningInfo.error}</Typography>:<div>
            <Typography style={{marginBottom: 20}} variant='h6'>
                <b>{this.state.wordMeaningInfo?.word}</b>
                    &nbsp;{this.state.wordMeaningInfo?.phonetic}&nbsp;

                    { (this.state.playComputer && !this.state.playRecording && this.state.url) ?
                        <IconButton><PauseIcon /></IconButton>
                         : <IconButton onClick={() => {this.playQueryText(this.state.wordMeaningInfo?.word);}}>
                            <PlayArrow/>
                           </IconButton>
                    }
                    </Typography>
                <Divider/>
                    <Typography variant='subtitle2'><ListItemText>{this.state.wordMeaningInfo?.partOfSpeech}</ListItemText>
                    <ListItemText style={{marginLeft:8}}>{this.state.wordMeaningInfo?.definition}</ListItemText></Typography>
        </div>
    }
    handleRestart=()=>{
        let bookId = localStorage.getItem("book_id");
        localStorage.setItem("current_section", JSON.stringify({ id: bookId, section: 0 }))
        blobIndex = 0;
        this.setState({ index: 0, blobArr: [], url: '', playComputer: false, playedSegment: false, isStoryComplete: false, restartBook: true });
        this.props.dispatch(getStoryAsLazy(this.props.id,0,200))
        this.props.dispatch(getStoryChapters(this.props.id));
    }

    render() {
        const analysis = this.state.analysis;
        var label = "My Turn";
        if (!(_.isEmpty(this.state.story)) && this.state.url.length === 0) {
            let storyLength = this.state.story.storySegmentDto.length;
            let lastIndex = this.state.story.storySegmentDto[storyLength - 1]?.section;
            if (this.state.index > lastIndex) {
                this.setState({ index: 0 });
            }
            // const storySegment = this.state.story.storySegmentDto[this.state.index];
            let storySegment = this.state.story.storySegmentDto.find(segment => segment.section == this.state.index);
            const { isModalOpen } = this.props.settings.modalState;
            if ((storySegment && storySegment.type === "Computer" && !this.state.playedSegment && !isModalOpen)) {
                this.playSegment(storySegment);
            }
            if (storySegment && storySegment.type !== "Computer") {
                label = "Your Turn";
            }
        }
        return (
            <PageVisibility onChange={this.handleVisibilityChange}>
                <>
                    <div className="bb_header">
                        <div className="bb_header_upper">
                            <div className="bb_header_progress">
                                <ProgressBar total={this.state?.story} current={this.state.index} storyId={this.props.id} isStoryComplete={this.state.isStoryComplete} playerType={this.state.playerType} restart={this.handleRestart} />
                            </div>
                            <div className="bb_header_setting">
                                <div onClick={this.handlePointer}>
                                    <QuestionMark style={{ cursor: "pointer" }} />
                                    <span id="qPointer" className="question_mark">
                                        <QuestionMark />
                                    </span>
                                </div>

                                <SettingModal
                                    sendSettings={this.getLocalSettings}
                                    toggleAudio={this.state.playerType ? this.togglePlayer : this.toggleComputerAudio}
                                    togglePlay={this.state.playerType ? this.state.isAppPaused : this.state.playComputer}
                                    playerType={this.state.playerType}
                                    changeToCurrentSection={this.resumeStory}
                                />
                            </div>
                        </div>
                        <div className="bb_header_lower">
                            <Timer
                                playComputer={this.state.playComputer}
                                playRecording={this.state.start}
                                audioUrl={this.state.url}
                            />
                        </div>
                    </div>
                    <div className="centerText">
                        <div className="innerText">
                            <div className="leftContainer">
                                <div className="instructions" style={{ color: this.state?.settings?.fontColor }}>
                                    {label}
                                </div>

                                <div className="btnGroup">
                                    {
                                        this.state.playerType ?
                                            <Tooltip title="Click to record" arrow>
                                                <IconButton id="recordBtn" variant="contained" onClick={() => { resetRecording = false; this.state.recording() }}>
                                                    <RecordVoiceOverIcon className={this.state.start ? "start" : null} />
                                                </IconButton>
                                            </Tooltip>
                                            :
                                            <Tooltip title="Hearing" arrow>
                                                <IconButton variant="contained">
                                                    <HearingIcon className={this.state.playComputer ? "start" : ""} />
                                                </IconButton>
                                            </Tooltip>
                                    }

                                    {this.state.data && this.state.data.length > 0 && (
                                        <button onClick={URL.createObjectURL(this.state.data)}>Download</button>
                                    )}
                                </div>
                            </div>

                            {this.state.story ?
                                <div id="segmentSections" className="segmentContainer">
                                    <StoryPageParagraph
                                        index={this.state.index}
                                        highlightWordIndex={this.state.highlightWordIndex}
                                        playRecording={this.state.playRecording}
                                        playComputer={this.state.playComputer}
                                        fadeToggle={this.state.fadeToggle}
                                        allStorySegment={this.state.story.storySegmentDto}
                                        analysis={analysis}
                                        bbSettings={this.state.settings}
                                        blobIndex={blobIndex}
                                        storyChapters={this.state.storyChapters}
                                    />
                                </div> :
                                <div className='segmentContainer' style={{ textAlign: 'center' }}>
                                    <h2>Wait!!</h2>
                                    <h5>Your story is Loading...</h5>
                                </div>
                            }

                            <div className="rightContainer">
                                {this.state.url.length > 0 && this.state.playComputer && (
                                    <div style={{ display: 'none' }}>
                                        <audio
                                            id="compAud"
                                            controls
                                            ref={this.compAudRef}
                                            autoPlay
                                            // onPlay={this.handleStartComputerAudio}
                                            onEnded={this.handleEndComputerAudio}
                                            onTimeUpdate={(e) => {
                                                !this.props.settings.modalState.isQuestionClicked && this.iterateComputerAudio(e)
                                            }}>
                                            <source src={this.state.url} type={"audio/mpeg"} />
                                        </audio>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="pauseBtn">
                            {
                                this.state.playerType ?
                                    <PauseMenu
                                        toggleAudio={this.togglePlayer}
                                        analysis={analysis}
                                        togglePlay={this.state.isAppPaused}
                                        isSpacebarClicked={this.state.isSpacebarClicked}
                                        firstSpacebarPressed={firstSpacebarPressed}
                                        playerType={true}
                                        resumeStory={this.resumeStory}
                                        recordingText={this.state.recordingText}
                                        pageVisible={this.state.pageVisible}
                                        modalIsOpen={this.state.modalIsOpen}
                                    />
                                    :
                                    <PauseMenu
                                        toggleAudio={this.toggleComputerAudio}
                                        analysis={this.state.story && this.state.story.storySegment && JSON.parse(this.state.story.storySegmentDto[this.state.index].analysis)}
                                        togglePlay={this.state.playComputer}
                                        playerType={false}
                                        isSpacebarClicked={this.state.isSpacebarClicked}
                                        resumeStory={this.resumeStory}
                                        firstSpacebarPressed={firstSpacebarPressed}
                                        pageVisible={this.state.pageVisible}
                                        modalIsOpen={this.state.modalIsOpen}
                                    />
                            }
                        </div>
                        {
                            this.state.openDictionaryModal && 
                            (<Dialog
                                open={this.state.openDictionaryModal}
                                onClose={(e,reason)=>{if(!reason)this.closeDictionaryModal()}}
                                >
                                    <Box sx={{minWidth:600}}>
                                    <DialogContent>
                                    <IconButton
                                         style={{ float: 'right' }}
                                         onClick={this.closeDictionaryModal}>
                                            <CloseIcon/>
                                        </IconButton>
                                    {(this.state.wordMeaningInfo === "" && this.state.dictionaryLoading) ? 
                                    <div style={{textAlign:'center'}}><CircularProgress /> </div>
                                    : (this.state.wordMeaningInfo === "" ? "" : this.showDefinition())}
                                    </DialogContent>
                                    </Box>
                                </Dialog>)
                        }
                        {this.props?.settings.modalState.isQuestionClicked &&
                            <div className='queryText'>
                                {this.state.isIpad ? "Please hold your finger on a word to see its meaning. You can double-tap to return to the story at any time."
                                  : "Please double-click on any word to hear it pronounced. You can press escape to return to the story at any time."}
                            </div>
                        }
                        <div className="howItWorks">
                            <a href="https://docs.microsoft.com/en-us/legal/cognitive-services/speech-service/pronunciation-assessment/characteristics-and-limitations-pronunciation-assessment">Powered By Microsoft AI <img url="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt='' /></a>
                        </div>
                    </div>
                    {
                        this.state.isSearchBarVisible && (
                            <SearchBar
                                openSearchBar={this.openSearchBar}
                                closeSearchBar={this.closeSearchBar}
                                jumpToSection={this.jumpToSection}
                                bookId={this.props.id}
                            />
                        )
                    }
                </>
            </PageVisibility>
        )
    }
}


const mapState = ({ platform: { student, analysis: { studentSpeech, currentAnalysis, savedSessionResponse, book, localData, storyChapters, lazyStoryAdded, storyLength }, story, lazyStory, auth, settings } }) => {
    return {
        student,
        currentAnalysis,
        savedSessionResponse,
        story,
        auth,
        settings,
        book,
        localData,
        storyChapters,
        lazyStory,
        lazyStoryAdded,
        storyLength
    }
};

export default connect(mapState, null)(withStyles(baseStyle, { withTheme: true })(BuddyBooks));